import {HStack} from '../Stack';
import {emotionStyled, tokens} from '@packages/utilities/styled';

export const CheckboxWrapperView = emotionStyled(HStack)(
  {},
  {
    variants: {
      size: {
        medium: {
          gap: '$1',
        },
        'x-large': {
          gap: '$2',
        },
      },
      isDisabled: {
        true: {
          opacity: tokens.opacities.disabled,
          '&, & *': {
            cursor: 'not-allowed !important',
          },
        },
      },
    },
  }
);

export const CheckboxInputWrapperView = emotionStyled('div')({
  position: 'relative',
  display: 'inline-flex',
  alignItems: 'center',
});

export const CheckboxInputView = emotionStyled('input')(
  {
    appearance: 'none',
    bottom: 0,
    left: 0,
    margin: 0,
    opacity: 0,
    position: 'absolute',
    right: 0,
    top: 0,
    '&:hover': {
      cursor: 'pointer',
    },
  },
  {
    variants: {
      size: {
        medium: {
          '&:hover': {
            // All interactive content in Designer uses `cursor: default`
            cursor: 'default',
          },
        },
        'x-large': {},
      },
    },
  }
);

const BACKGROUND_CHECKED = '--local-checkbox-background-checked';
const BACKGROUND_CHECKED_HOVER = '--local-checkbox-background-checked-hover';
const BORDER_UNCHECKED = '--local-checkbox-border';
const BORDER_CHECKED = '--local-checkbox-border-checked';
const BORDER_CHECKED_HOVER = '--local-checkbox-border-checked-hover';

export const CheckboxButtonView = emotionStyled('div')(
  {
    alignItems: 'center',
    backgroundColor: '$background1',
    borderColor: `var(${BORDER_UNCHECKED}, $uiCheckboxRadioBorderColor)`,
    borderRadius: '$1',
    borderStyle: 'solid',
    borderWidth: tokens.controls.borderWidth,
    color: '$actionPrimaryText',
    display: 'flex',
    height: tokens.ui.checkbox.boxSize,
    width: tokens.ui.checkbox.boxSize,
    justifyContent: 'center',
    outlineOffset: 1,
    pointerEvents: 'none',
    position: 'relative',

    [`${CheckboxInputView}:hover + &`]: {
      backgroundColor: '$background2',
    },

    [`${CheckboxInputView}:focus-visible + &`]: {
      outlineColor: '$blueBorder',
      outlineStyle: 'solid',
      outlineWidth: 1,
    },
  },
  {
    variants: {
      colorVariant: {
        blue: {
          [BACKGROUND_CHECKED]: tokens.colors.blueBackground,
          [BACKGROUND_CHECKED_HOVER]:
            tokens.colors.actionPrimaryBackgroundHover,
          [BORDER_UNCHECKED]: tokens.colors.uiCheckboxRadioBorderColor,
          [BORDER_CHECKED]: tokens.colors.actionPrimaryBackground,
          [BORDER_CHECKED_HOVER]: tokens.colors.actionPrimaryBackgroundHover,
        },
        purple: {
          [BACKGROUND_CHECKED]: tokens.colors.purpleBackground,
          [BACKGROUND_CHECKED_HOVER]: tokens.colors.purpleBackgroundHover,
          [BORDER_UNCHECKED]: tokens.colors.purpleBorder,
          [BORDER_CHECKED]: tokens.colors.purpleBackground,
          [BORDER_CHECKED_HOVER]: tokens.colors.purpleBackgroundHover,
        },
        green: {
          [BACKGROUND_CHECKED]: tokens.colors.greenBackground,
          [BACKGROUND_CHECKED_HOVER]: tokens.colors.greenBackgroundHover,
          [BORDER_UNCHECKED]: tokens.colors.greenBorder,
          [BORDER_CHECKED]: tokens.colors.greenBackground,
          [BORDER_CHECKED_HOVER]: tokens.colors.greenBackgroundHover,
        },
      },
      isChecked: {
        true: {
          backgroundColor: `var(${BACKGROUND_CHECKED})`,
          borderColor: `var(${BORDER_CHECKED})`,
          [`${CheckboxInputView}:hover + &`]: {
            backgroundColor: `var(${BACKGROUND_CHECKED_HOVER})`,
            borderColor: `var(${BORDER_CHECKED_HOVER})`,
          },
        },
      },
      isIndeterminate: {
        true: {
          backgroundColor: `var(${BACKGROUND_CHECKED})`,
          borderColor: `var(${BORDER_CHECKED})`,
          '> *': {
            width: '6px !important',
            height: '6px !important',
            margin: 0,
          },
          [`${CheckboxInputView}:hover + &`]: {
            backgroundColor: `var(${BACKGROUND_CHECKED_HOVER})`,
            borderColor: `var(${BORDER_CHECKED_HOVER})`,
          },
        },
      },
      isError: {
        true: {
          [BACKGROUND_CHECKED]: tokens.colors.redBackground,
          [BACKGROUND_CHECKED_HOVER]: tokens.colors.redBackgroundHover,
          [BORDER_UNCHECKED]: tokens.colors.redBorder,
          [BORDER_CHECKED]: tokens.colors.redBackground,
          [BORDER_CHECKED_HOVER]: tokens.colors.redBackgroundHover,
        },
      },
      // Styles for isDisabled are handled in CheckboxWrapperView, so nothing to add here
      isDisabled: {
        true: {},
      },
    },
  }
);

export const IndeterminateIconView = emotionStyled('div')({
  display: 'flex',
  marginTop: '1px',
  justifyContent: 'center',
});
